import Number from './NumberInputForm';
import Text from './TextInputForm';
import Mask from './MaskInputForm';
import Select from './SelectInputForm';
import Checkbox from './CheckboxInputForm';
import Field from './FieldInputForm';
import Switch from './SwitchElem';


export default { Number, Text, Mask, Select, Checkbox, Field, Switch,  };
